export default __webpack_public_path__ + "static/media/evaluate.d71d504f.svg";